/**
 * 팝업 backdrop 드래그 오감지 방지 유틸
 *
 * 사용법:
 *   import { onBackdropMouseDown, onBackdropClick } from '../utils/modalDrag';
 *
 *   <div className="modal ..."
 *     onMouseDown={onBackdropMouseDown}
 *     onClick={(e) => onBackdropClick(e, () => setOpen(false))}>
 */

let _backdropMouseDownTarget = null;

export function onBackdropMouseDown(e) {
  _backdropMouseDownTarget = e.target;
}

export function onBackdropClick(e, close) {
  if (e.target === e.currentTarget && _backdropMouseDownTarget === e.currentTarget) {
    close();
  }
}
